/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMap: {
  name: 'map';
  data: string;
} = {
  name: 'map',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.526 3.15A1 1 0 0 1 21 4v13a1 1 0 0 1-.553.894l-6 3a1 1 0 0 1-.961-.036L9 18.166l-4.486 2.692A1 1 0 0 1 3 20V7a1 1 0 0 1 .486-.857l5-3a1 1 0 0 1 1.028 0l4.53 2.717 5.509-2.754a1 1 0 0 1 .973.043ZM19 5.617l-4 2v10.764l4-2V5.618Zm-9 .148 3 1.8v10.668l-3-1.8V5.766Zm-2 0-3 1.8v10.668l3-1.8V5.766Z" fill="currentColor"/></svg>`,
};
